import { IObject } from "../../contracts";
import { IMapperProfile } from "../../contracts/IMapper";

export namespace MapperHelper {

    export function mapTo<TSource extends IObject, TDestination extends IObject>(profile: IMapperProfile<TSource, TDestination>, source: TSource): TDestination | undefined {
        return profile.mapTo(source);
    }

    export function mapFrom<TSource extends IObject, TDestination extends IObject>(profile: IMapperProfile<TSource, TDestination>, source: TDestination | undefined): TSource | undefined {
        return profile.mapFrom(source);
    }

    export function mapToArray<TSource extends IObject, TDestination extends IObject>(profile: IMapperProfile<TSource, TDestination>, source: TSource[]): TDestination[] {
        const destination: TDestination[] = [];

        if (source === undefined || source === null) {
            return destination;
        }

        source.map((item) => {
            const value: TDestination | undefined = profile.mapTo(item);
            if (value !== undefined) {
                destination.push(value);
            }
        })

        return destination;
    }

    export function mapFromArray<TSource extends IObject, TDestination extends IObject>(profile: IMapperProfile<TSource, TDestination>, source: TDestination[]): TSource[] {
        const destination: TSource[] = [];

        if (source === undefined || source === null) {
            return destination;
        }

        source.map((item) => {
            const value: TSource | undefined = profile.mapFrom(item);
            if (value !== undefined) {
                destination.push(value);
            }
        })

        return destination;
    }
}
